module.exports = __webpack_public_path__ + "static/media/standart.395e7e3e.less";